import { EMAIL_ENCODING_SALT } from "../constants";
import * as qs from "qs";

// Dummy data create for table
export function createData(
  name,
  jobTitle,
  company,
  contactLocation,
  employees,
  industry,
  keywords,
  email,
  associatedComapny
) {
  return {
    name: name,
    jobTitle: jobTitle,
    company: company,
    contactLocation: contactLocation,
    employees: employees,
    industry: industry,
    keywords: keywords,
    email: email,
    actions: "Save",
    associatedComapny: associatedComapny,
  };
}

export const generateRandomColor = () => {
  const colors = [
    "#7954F6",
    "#3ACAF9",
    "#F6DF5D",
    "#11D69F",
    "#EE3962",
    "#F77F53",
    "#663E70",
  ];
  const index = Math.floor(Math.random(0, 100) * colors.length);
  return colors[index];
};

export const cipher = () => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars(EMAIL_ENCODING_SALT).reduce((a, b) => a ^ b, code);
  return (text) =>
    text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};

export const encryptEmail = (email) => {
  let res = cipher();
  return res(email);
};

const decipher = () => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) =>
    textToChars(EMAIL_ENCODING_SALT).reduce((a, b) => a ^ b, code);
  return (encoded) =>
    encoded
      .match(/.{1,2}/g)
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join("");
};

export const decryptEmail = (text) => {
  try {
    const myDecipher = decipher();
    return myDecipher(text);
  } catch (error) {
    console.log('error inside decryption', error);
    return error
  }
};

export const dragArrayIndexes = (array, sourceIndex, destinationIndex) => {
  let result = [];
  for (let i = 0; i < array.length; i++) {
    if (i !== sourceIndex) {
      result.push(array[i]);
    }
    if (i === destinationIndex) {
      result.push(array[sourceIndex]);
    }
  }
  return result;
};

export const removeObjFromArray = (arr, obj) => {
  let filtered = arr.filter(function (el) {
    return el.id !== obj.id;
  });
  return filtered;
};

export const getGoogleAuthURL = (
  mail_access = false,
  calendar_access = false,
  connect_inbox = false
) => {
  try {
    let scope = process.env.REACT_APP_GOOGLE_SCOPE?.split(", ");
    let emailScope = "https://mail.google.com";
    let calendarScope = "https://www.googleapis.com/auth/calendar";
    if (mail_access && !calendar_access) {
      scope = scope?.filter((item) => item !== calendarScope);
    } else if (!mail_access && calendar_access) {
      scope = scope?.filter((item) => item !== emailScope);
    }

    const rootUrl = process.env.REACT_APP_GOOGLE_ROOT_URL;
    const options = {
      redirect_uri: connect_inbox ? process.env.REACT_APP_GOOGLE_CONNECT_INBOX_REDIRECT_URI : process.env.REACT_APP_GOOGLE_REDIRECT_URI,
      client_id: process.env.REACT_APP_GOOGLE_CLIENTID,
      access_type: process.env.REACT_APP_GOOGLE_ACCESS_TYPE,
      response_type: process.env.REACT_APP_GOOGLE_RESPONSE_TYPE,
      prompt: process.env.REACT_APP_GOOGLE_PROMPT,
      scope: scope?.join(" "),
    };
    // Fix #7: removed console.log that leaked the full Google OAuth URL.
    return `${rootUrl}?${qs.stringify(options)}`;
  } catch (error) {
    return error;
  }
};

// REACT_APP_MICROSOFT_ROOT_URL = https://login.microsoftonline.com
// REACT_APP_MICROSOFT_TENANT_ID = 4ec4c4a3-704a-443a-90ab-f337896dfd3e
// REACT_APP_MICROSOFT_CLIENT_ID = 0596cf36-aa34-45a2-adee-55e92ba1d076
// REACT_APP_MICROSOFT_RESPONSE_TYPE = code
// REACT_APP_MICROSOFT_REDIRECT_URI = https%3A%2F%2Fregistration.reachiq.io%2Fauth%2Fmicrosoft-web-verify
// REACT_APP_MICROSOFT_RESPONSE_MODE = query
// REACT_APP_MICROSOFT_SCOPE = https%3A%2F%2Fgraph.microsoft.com%2FUser.Read+offline_access
// REACT_APP_MICROSOFT_SSO_RELOAD = true
// REACT_APP_MICROSOFT_STATE = randomstring

//  https://login.microsoftonline.com/4ec4c4a3-704a-443a-90ab-f337896dfd3e/oauth2/v2.0/authorize?client_id=0596cf36-aa34-45a2-adee-55e92ba1d076
//    &response_type=code
//    &redirect_uri=https%3A%2F%2Fregistration.reachiq.io%2Fauth%2Fmicrosoft-web-verify&response_mode=query
//  &scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read+offline_access
//  &state=12345&sso_reload=true

// Zoho Mail connect (esp 8) — mirrors getGoogleAuthURL/getMicrosoftAuthURL.
// Zoho is region-sharded: consent starts at REACT_APP_ZOHO_ROOT_URL (accounts.zoho.in
// for our client) and Zoho appends `location` + `accounts-server` params on the
// callback, which ConnectInboxZohoRedirectScreen forwards to the backend.
export const getZohoAuthURL = () => {
  try {
    const rootUrl = process.env.REACT_APP_ZOHO_ROOT_URL; // e.g. https://accounts.zoho.in/oauth/v2/auth
    const options = {
      response_type: "code",
      client_id: process.env.REACT_APP_ZOHO_CLIENTID,
      scope: process.env.REACT_APP_ZOHO_SCOPE, // ZohoMail.accounts.READ,ZohoMail.messages.ALL,ZohoMail.folders.READ
      redirect_uri: process.env.REACT_APP_ZOHO_CONNECT_INBOX_REDIRECT_URI, // https://registration.reachiq.ai/auth/zoho-connect-inbox
      access_type: "offline",
      prompt: "consent",
    };
    return `${rootUrl}?${qs.stringify(options)}`;
  } catch (error) {
    return error;
  }
};

export const getMicrosoftAuthURL = (connect_inbox = false) => {
  try {
    const rootUrl = process.env.REACT_APP_MICROSOFT_ROOT_URL;
    const microsoft_auth_url = `${rootUrl}/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_MICROSOFT_CLIENT_ID}&response_type=${process.env.REACT_APP_MICROSOFT_RESPONSE_TYPE}&redirect_uri=${connect_inbox ? process.env.REACT_APP_MICROSOFT_CONNECT_INBOX_REDIRECT_URI : process.env.REACT_APP_MICROSOFT_REDIRECT_URI}&response_mode=${process.env.REACT_APP_MICROSOFT_RESPONSE_MODE}&scope=${process.env.REACT_APP_MICROSOFT_SCOPE}&state=${process.env.REACT_APP_MICROSOFT_STATE}&sso_reload=${process.env.REACT_APP_MICROSOFT_SSO_RELOAD}&prompt=select_account`;
    return microsoft_auth_url;
  } catch (error) {
    return error;
  }
};
